import { IObservable, Subject } from '~/rage/utils';

import { IRpcService } from '../RpcService';

export class VarsService {
	private readonly vars: Map<string, Subject<any>> = new Map();
	private readonly chunks = new Map<number, string>();

	constructor(rpc: IRpcService) {
		rpc.register('vars:set', (payload: { name: string; value: any }) => {
			this.set(payload.name, payload.value);
		});
		rpc.register(
			'vars:chunk',
			({ id, chunk }: { id: number; chunk: string }) => {
				this.chunks.set(id, (this.chunks.get(id) ?? '') + chunk);
			},
		);
		rpc.register(
			'vars:chunkEnd',
			({ id, name, length }: { id: number; name: string; length: number }) => {
				const value = this.chunks.get(id) ?? '';
				this.chunks.delete(id);
				if (value.length !== length) {
					throw new Error(
						`Incomplete GUI variable ${name}: ${value.length}/${length} characters`,
					);
				}
				this.set(name, JSON.parse(value));
			},
		);

		if (import.meta.env.DEV) {
			(window as any)['setvar'] = (name: string, value: any) => {
				this.set(name, value);
			};
		}
	}

	public get<T>(name: string, defaultValue: T): IObservable<T> {
		if (!this.vars.has(name)) {
			this.vars.set(name, new Subject<T>(defaultValue));
		}

		return this.vars.get(name) as IObservable<T>;
	}

	public set<T>(name: string, value: T): void {
		if (!this.vars.has(name)) {
			this.vars.set(name, new Subject(value));
		} else {
			this.vars.get(name)!.next(value);
		}
	}
}
